import Vue from "vue";
import Router from "vue-router";
import { rootFile } from "api/config";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: rootFile,
  // eslint-disable-next-line no-sparse-arrays
  routes: [
    {
      path: "/",
      redirect: "/inviteFriends/app",
    },
    {
      path: "/userGuidance/index",
      name: "userGuidanceIndex",
      meta: {
        title: "使用指南",
      },
      component: (resolve) => {
        import("components/userGuidance/index").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/inviteFriends/app",
      name: "inviteFriendsApp",
      meta: {
        title: "邀请好友帮助",
      },
      component: (resolve) => {
        import("components/inviteFriends/app").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/inviteFriends/miniApp",
      name: "inviteFriendsMiniApp",
      meta: {
        title: "邀请好友帮助",
      },
      component: (resolve) => {
        import("components/inviteFriends/miniApp").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/recruit/index",
      name: "recruitIndex",
      meta: {
        title: "新干线观察",
      },
      component: (resolve) => {
        import("components/recruit/index").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/sharecoupons/:shareVoucher",
      name: "sharecoupons",
      meta: {
        title: "新干线观察",
      },
      component: (resolve) => {
        import("components/xbshare/share_coupons").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/businesscoupons/:voucherinfo",
      name: "businesscoupons",
      meta: {
        title: "新干线观察",
      },
      component: (resolve) => {
        import("components/xbshare/share_coupons").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/sharebusiness/:bussinessInfo",
      name: "sharebusdetail",
      meta: {
        title: "商家主页",
      },
      component: (resolve) => {
        import("components/xbshare/share_busdetail").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/safariGuide/:id?",
      name: "safariGuide",
      meta: {
        title: "新干线观察",
      },
      component: (resolve) => {
        import("components/xbshare/safariGuide").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/linkphone/:key",
      name: "linkphone",
      meta: {
        title: "邀请",
      },
      component: (resolve) => {
        import("components/xbshare/linkphone").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/receivecoupon/:key",
      name: "receivecoupon",
      meta: {
        title: "新干线观察",
      },
      component: (resolve) => {
        import("components/xbshare/receivecoupon").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/linknone/:message",
      name: "linknone",
      meta: {
        title: "暂无",
      },
      component: (resolve) => {
        import("components/xbshare/linknone").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/openlink",
      name: "openlink",
      meta: {
        title: "",
      },
      component: (resolve) => {
        import("components/xbshare/openlink").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/jxylink",
      name: "jxylink",
      meta: {
        title: "西本加西亚",
      },
      component: (resolve) => {
        import("components/xbshare/jxylink").then((module) => {
          resolve(module);
        });
      },
    },
    //   {
    //     path: '/li/:type/:authCode',
    //     name: 'linkInvite',
    //     meta: {
    //         title: '邀请'
    //       },
    //     component: (resolve) => {
    //         import('components/xbshare/linkInvite').then((module) => {
    //           resolve(module)
    //         })
    //       }
    //   },
    {
      path: "/li/:type/:authCode",
      name: "linkInvite",
      meta: {
        title: "邀请",
      },
      component: (resolve) => {
        import("components/xbshare/friendInvited").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/scd/:authCode",
      name: "shareCompanyDetail",
      meta: {
        title: "商家主页",
      },
      component: (resolve) => {
        import("components/xbshare/shareCompanyDetail").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/spd/:authCode",
      name: "shareProductDetail",
      meta: {
        title: "商品主页",
      },
      component: (resolve) => {
        import("components/xbshare/shareProductDetail").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/rg/:authCode",
      name: "receiveGift",
      meta: {
        title: "新干线观察商品赠送",
      },
      component: (resolve) => {
        import("components/xbshare/receiveGift").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/charts",
      name: "charts",
      meta: {
        title: "环形图",
      },

      component: (resolve) => {
        import("components/xbshare/charts").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/charts1",
      name: "charts1",
      meta: {
        title: "环形图",
      },

      component: (resolve) => {
        import("components/xbshare/charts1").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/charts/curve",
      name: "chartsCurve",
      meta: {
        title: "曲线图",
      },

      component: (resolve) => {
        import("components/xbshare/chartsCurve").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/charts/empower/pie",
      name: "chartsEmpowerPie",
      meta: {
        title: "赋能环形图",
      },

      component: (resolve) => {
        import("components/xbshare/chartsEmpowerPie").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/charts/empower/brokenLine",
      name: "chartsEmpowerBrokenLine",
      meta: {
        title: "赋能环形图",
      },

      component: (resolve) => {
        import("components/xbshare/chartsEmpowerBrokenLine").then((module) => {
          resolve(module);
        });
      },
    },

    {
      path: "/rightsAndInterests",
      name: "rightsAndInterests",
      meta: {
        title: "等级权益说明",
      },
      component: (resolve) => {
        import("components/xbshare/rightsAndInterests").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/classRules",
      name: "classRules",
      meta: {
        title: "晋级说明",
      },
      component: (resolve) => {
        import("components/xbshare/classRules").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/observeInvitation",
      name: "observeInvitation",
      meta: {
        title: "邀请",
      },
      component: (resolve) => {
        import("components/xbshare/observeInvitation").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/shareH5",
      name: "shareH5",
      meta: {
        title: "  ",
      },
      component: (resolve) => {
        import("components/xbshare/shareH5").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/testLinkWx",
      name: "testLinkWx",
      meta: {
        title: "  ",
      },
      component: (resolve) => {
        import("components/xbshare/testLinkWx").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/testLinkWx1",
      name: "testLinkWx1",
      meta: {
        title: "  ",
      },
      component: (resolve) => {
        import("components/xbshare/testLinkWx1").then((module) => {
          resolve(module);
        });
      },
    },
    //   {
    //     path: '/friendInvited/:type/:authCode',
    //     name: 'friendInvited',
    //     meta: {
    //         title: '邀请链接'
    //       },
    //     component: (resolve) => {
    //         import('components/xbshare/friendInvited').then((module) => {
    //           resolve(module)
    //         })
    //       }
    //   },
    {
      path: "/complaint",
      name: "complaint",
      meta: {
        title: "投诉意见",
      },
      component: (resolve) => {
        import("components/xbshare/complaint").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/energizeHelp",
      name: "energizeHelp",
      meta: {
        title: "赋能帮助",
      },
      component: (resolve) => {
        import("components/xbshare/energizeHelp").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/yearAssessmentNightingaleChart/:companyId/:userId/:isManager?",
      name: "yearAssessmentNightingaleChart",
      meta: {
        title: "年度考核",
      },
      component: (resolve) => {
        import("components/xbshare/yearAssessmentNightingaleChart").then(
          (module) => {
            resolve(module);
          }
        );
      },
    },
    {
      path: "/personalData/:userId?/:version?/:key?/:channel?",
      name: "personalData",
      meta: {
        title: "报名表",
        mode: "edit",
      },
      component: (resolve) => {
        import("components/xbshare/personalData").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/personalDataLook/:userId?/:version?/:key?/:channel?",
      name: "personalDataLook",
      meta: {
        title: "报名表",
        mode: "look", // 只查看
      },
      component: (resolve) => {
        import("components/xbshare/personalData").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/secreteprotocaloa",
      name: "secreteprotocaloa",
      meta: {
        title: "西本加西亚用户隐私政策",
      },
      component: (resolve) => {
        import("components/xbshare/secreteprotocaloa").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/protocal",
      name: "protocal",
      meta: {
        title: "西本加西亚用户协议",
      },
      component: (resolve) => {
        import("components/xbshare/protocal").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/agentprotocal",
      name: "agentprotocal",
      meta: {
        title: "代言说明",
      },
      component: (resolve) => {
        import("components/xbshare/agentprotocal").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/pmi_help",
      name: "pmi_help",
      meta: {
        title: "帮助",
      },
      component: (resolve) => {
        import("components/xbshare/pmi_help").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/companyprotocal",
      name: "companyprotocal",
      meta: {
        title: "新干线观察商家服务协议",
      },
      component: (resolve) => {
        import("components/xbshare/companyprotocal").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/agentprotocal_",
      name: "agentprotocal_",
      meta: {
        title: "代言说明",
      },
      component: (resolve) => {
        import("components/xbshare/agentprotocal_").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/secreteprotocal_",
      name: "secreteprotocal_",
      meta: {
        title: "用户隐私政策",
      },
      component: (resolve) => {
        import("components/xbshare/secreteprotocal_").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/pmprotocal_",
      name: "pmprotocal_",
      meta: {
        title: "新干线观察用户注册协议",
      },
      component: (resolve) => {
        import("components/xbshare/pmprotocal_").then((module) => {
          resolve(module);
        });
      },
    },
    {
      path: "/introductionPage",
      name: "introductionPage",
      meta: {
        title: "介绍",
      },
      component: () => import("@/pages/introductionPage"), // 使用 @ 来指代 src 文件夹
      // 更新为新文件夹的路径
    },
    {
      path: "/registration",
      name: "registration",
      meta: {
        title: "报名表",
      },
      component: () => import("@/pages/registration"), // 使用 @ 来指代 src 文件夹
      // 更新为新文件夹的路径
    },

    {
      path: "*",
      redirect: "/openlink",
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js